import styled from "styled-components";

/**
 * Wrapper principal do rodapé (Mobile)
 */
export const FooterWrapperMobile = styled.footer`
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: ${({ theme }) => theme.spacing(4)};
  padding: ${({ theme }) => theme.spacing(4)} 0 0;
  background-color: ${({ theme }) => theme.colors.lightBlue};
`;

/**
 * Conteúdo do rodapé (Mobile)
 */
export const FooterContentMobile = styled.div`
  padding-right: ${({ theme }) => theme.spacing(2)};
  padding-left: ${({ theme }) => theme.spacing(2)};
  gap: ${({ theme }) => theme.spacing(4)};
  justify-content: space-between;
  flex-direction: column;
  max-width: 540px;
  margin: 0 auto;
  display: flex;
`;

/**
 * Wrapper do logo (Mobile)
 */
export const LogoWrapperMobile = styled.a`
  text-align: center;

  & > svg {
    width: ${({ theme }) => theme.spacing(26)};
    height: ${({ theme }) => theme.spacing(11)};
  }
`;

/**
 * Wrapper do menu de navegação (Mobile)
 */
export const NavWrapperMobile = styled.nav`
  display: flex;
  justify-content: center;
  flex: 2;

  & > ul {
    display: flex;
    flex-direction: column;
    gap: ${({ theme }) => theme.spacing(1)};

    & > li {
      color: ${({ theme }) => theme.colors.darkBlue};
      border: none;
    }
  }
`;

/**
 * Descrição do rodapé (Mobile)
 */
export const NavDescriptionMobile = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${({ theme }) => theme.spacing(2)};
`;

/**
 * Wrapper dos botões (Mobile)
 */
export const ButtonWrapperMobile = styled.div`
  display: flex;
  justify-content: flex-end;
  flex: 1;
`;
